import originJSONP from "jsonp"

interface Options {
  param?: string
  prefix?: string
  name?: string
  timeout?: number
}

function jsonp(url: string, params?: Options): Promise<any> {
  return new Promise((resolve, reject) => {
    originJSONP(url, params, (err, data) => {
      if (err) {
        reject(err)
      } else {
        resolve(data)
      }
    })
  })
}

export default jsonp
